import {
  Grid,
  Typography,
  Divider,
  Box,
  Chip,
  Paper,
  Button,
  TextField,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  InputAdornment,
  MenuItem,
  GlobalStyles,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useIntl } from "react-intl";
import ModalComponent from "components/Modal";
import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { numericFormatter } from "react-number-format";

import { useSelector } from "react-redux";
import { StoreType } from "../../types/genericTypes";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import CategoriesList from "examples/Lists/CategoriesList";
import SearchIcon from "@mui/icons-material/Search";

interface TipoProducto {
  id: number;
  id_producto: number;
  id_talla_brimagy: number;
  talla: string;
  estatus: number;
}

interface DetalleTipoProductoProps {
  verTiposProducto?: TipoProducto[] | null;
  handleisAlertCrearTipoProductoOpen: () => void;
  desactivarTipoProducto: (datos: any) => Promise<void>;
  activarTipoProducto: (datos: any) => Promise<void>;
  setVerEditarTipoProducto: React.Dispatch<React.SetStateAction<any>>;
  handleisAlertOpenEditarTipoProducto: () => void;
  tipoProductosPaginados: TipoProducto[];
  page: number;
  rowsPerPage: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  buscador: string;
  handleBuscadorChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TiposProducto = ({
  verTiposProducto,
  handleisAlertCrearTipoProductoOpen,
  desactivarTipoProducto,
  activarTipoProducto,
  setVerEditarTipoProducto,
  handleisAlertOpenEditarTipoProducto,
  tipoProductosPaginados,
  page,
  rowsPerPage,
  handleChangePage,
  buscador,
  handleBuscadorChange,
  handleChangeRowsPerPage,
}: DetalleTipoProductoProps) => {
  if (!verTiposProducto) return null;
  const intl = useIntl();

  const getEstado = (estado: number) => {
    switch (estado) {
      case 1:
        return "success";
      case 0:
        return "error";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "ACTIVADO",
    0: "DESACTIVADO",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la talla */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#004c93", textAlign: { xs: "center", md: "left" } }}
                >
                  Tipos producto registrados
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#041d45",
                      borderRadius: "10px 0 0 10px",
                      px: .5,
                      boxSizing: "border-box",
                    }}
                  >
                    <SearchIcon fontSize="medium" sx={{ color: "#fff" }} />
                  </Box>
                  <TextField
                    id="outlined-basic"
                    fullWidth
                    size="small"
                    label={intl.formatMessage({ id: "input_buscador" })}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0 10px 10px 0",
                      },
                      "& .MuiInputLabel-root": {
                        color: "#041d45",
                        fontWeight: 500,
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#041d45",
                      },
                      "& .MuiInputLabel-shrink": {
                        background: "#fff",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #041d45",
                      },
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #041d45",
                      },
                    }}
                    onChange={handleBuscadorChange}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "end" },
                  marginTop: { xs: 2, md: 0 },
                }}
              >
                <Button
                  sx={{ color: "#fff", background: "#041d45" }}
                  variant="contained"
                  endIcon={<AddBoxIcon />}
                  onClick={(e: any) => {
                    handleisAlertCrearTipoProductoOpen();
                  }}
                >
                  {intl.formatMessage({ id: "añadir_tipo_producto" })}
                </Button>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verTiposProducto.length > 0 ? (
              <>
                {verTiposProducto.map((c: any, key: number) => (
                  <>
                    <Grid container spacing={2} key={key}>
                      <Grid item xs={6} md={2}>
                        <Typography variant="body2" color="text.secondary">
                          Clave
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          sx={
                            c.estatus === 0
                              ? {
                                color: "#7a7a7a",
                                textDecoration: "line-through",
                                textDecorationColor: "red",
                              }
                              : {}
                          }
                        >
                          {c?.clave}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">
                          Nombre
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          sx={
                            c.estatus === 0
                              ? {
                                color: "#7a7a7a",
                                textDecoration: "line-through",
                                textDecorationColor: "red",
                              }
                              : {}
                          }
                        >
                          {c?.nombre}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body2" color="text.secondary">
                          Descripción
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          sx={
                            c.estatus === 0
                              ? {
                                color: "#7a7a7a",
                                textDecoration: "line-through",
                                textDecorationColor: "red",
                              }
                              : {}
                          }
                        >
                          {c?.descripcion}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <Typography variant="body2" color="text.secondary">
                          Estatus
                        </Typography>
                        <Chip
                          label={traducirEstado(c?.estatus)}
                          color={getEstado(c?.estatus)}
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        />
                      </Grid>
                      <Grid item xs={6} md={1}>
                        <Typography variant="body2" color="text.secondary">
                          Acciones
                        </Typography>
                        {c?.estatus === 1 && (
                          <Tooltip title="Editar tipo producto">
                            <IconButton
                              aria-label="ver"
                              size="small"
                              color="warning"
                              onClick={() => {
                                setVerEditarTipoProducto(c);
                                handleisAlertOpenEditarTipoProducto();
                              }}
                            >
                              <EditNoteIcon fontSize="medium" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {c?.estatus === 1 ? (
                          <Tooltip title="Desactivar tipo producto">
                            <IconButton
                              aria-label="ver"
                              size="small"
                              color="error"
                              onClick={() => {
                                const datos = {
                                  id_tipo_producto: c?.id,
                                };
                                desactivarTipoProducto(datos);
                              }}
                            >
                              <DisabledByDefaultIcon fontSize="medium" />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Activar tipo producto">
                            <IconButton
                              aria-label="ver"
                              size="small"
                              color="success"
                              onClick={() => {
                                const datos = {
                                  id_tipo_producto: c?.id,
                                };
                                activarTipoProducto(datos);
                              }}
                            >
                              <CheckCircleOutlineIcon fontSize="medium" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                    <Divider sx={{ m: 1 }} />
                  </>
                ))}

                <MDBox
                  mt={3}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    justifyContent: "center",
                  }}
                >
                  <GlobalStyles
                    styles={{
                      ".MuiTablePagination-select.MuiSelect-standard": {
                        color: "#000 !important",
                        WebkitTextFillColor: "#000 !important",
                      },
                    }}
                  />
                  <TablePagination
                    component="div"
                    count={tipoProductosPaginados?.length ?? 0}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[3, 6, 10, 15]}
                    labelRowsPerPage="Tipos de producto por página:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    sx={{
                      color: "#000",
                      direction: "ltr",
                      ".MuiTablePagination-toolbar": {
                        justifyContent: "space-between",
                        padding: "16px 24px",
                      },
                      ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                        margin: 0,
                      },
                      ".MuiTablePagination-actions svg": {
                        transform: "scaleX(-1)",
                      },
                    }}
                  />
                </MDBox>
              </>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default TiposProducto;
